import Api from '@/services/api';
import qs from 'querystring';

export default {
  search(value, fields, filters = [], hiddenFilter = '', page = 1, sortBy = 'nom_soc', sortDesc , activeCreditor = true) {
    return Api().post('/creditors/search', qs.stringify({
      'search': value,
      'fields': fields,
      'filters': JSON.stringify(filters),
      'hiddenFilter': hiddenFilter,
      'page': page,
      'sortBy': sortBy,
      'sortDesc': sortDesc,
      'active': activeCreditor
    }));
  },
  orderWarrants(n) {
    return Api().get('/client/creditor/order-warrants/' + n)
  },
  nextUnusedWarrant() {
    return Api().get('/client/creditor/next-unused-warrant');
  },
  timeline(month = '', year = '') {
    return Api().get('/client/creditor/timeline?month=' + month + '&year=' + year)
  },
  purchaseOrder(data) {
    return Api().get('/purchase-order?' + data);
  },
  get(id) {
    return Api().get('/client/creditor/' + id);
  },
  getStats() {
    return Api().get('/client/creditor/stats')
  },
  getStatsRange(start, end) {
    return Api().get('/client/creditor/stats?start=' + start + '&end=' + end)
  },
  getExpired(id, total = false) {
    return Api().get('/creditor/expired-warrants/' + id + "?total=" + (total ? 'true' : 'false'));
  },
  createNotebook(id, data) {
    return Api().post('/creditor/notebook/' + id, qs.stringify({
      data: JSON.stringify(data)
    }))
  },
  post(creditorObject) {
    return Api().post('/creditor', qs.stringify({
      object: JSON.stringify(creditorObject)
    }));
  },
  toggleAge(id) {
    return Api().post('/creditor/' + id + '/toggle-age');
  },
  change_password(pwd) {
    return Api().post("/creditor/change-password", "pwd=" + encodeURIComponent(JSON.stringify(pwd)))
  },
  addNote(noteObject) {
    return Api().post('/creditor/' + noteObject.creditorID + '/note', qs.stringify({
      note: noteObject.note,
      negotiateurID: noteObject.negotiateurID
    }))
  },
  editNote(noteObject) {
    return Api().post('/creditor/' + noteObject.creditorID + '/note', qs.stringify({
      noteId: noteObject.noteID,
      note: noteObject.note,
      negotiateurID: noteObject.negotiateurID
    }))
  },
  deleteNote(noteObject) {
    return Api().delete('/creditor/' + noteObject.creditorID + '/note/' + noteObject.noteID);
  },
  invoices(id) {
    return Api().get('/creditor/invoices/' + id);
  },
  warrants(id, offset = 0) {
    return Api().get('/creditor/warrants/' + id + '?offset=' + offset)
  },
  payments(id) {
    return Api().get('/creditor/payments/' + id)
  },
  translateQuality(text) {
    return Api().get('/creditors/translate-quality/' + encodeURIComponent(text));
  }
}